//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PopupNotices from '@/components/popup/PopupNotices'

export default {
  name: "notify",
  components: {
    PopupNotices
  },
  data() {
    return {
      popupNoticesDisplay: false,
    }
  },
  computed: {
    notificationsCounter() {
      return this.$store.getters['notify/getNotificationsCount']
    },
    notificationsList() {
      return this.$store.getters['notify/getNotifications']
    }
  }
}
